module.exports = __webpack_public_path__ + "static/img/prq8.6c9d4a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/prq8.jpg
// module id = DJcr
// module chunks = 2